<template>
  <div>
    <header>
      <div class="logo-con">
        <img src="../../assets/images/logo.png" key="max-logo" />
        <span>就业云</span>
      </div>
      <div>
        <router-link class="login-url" to="login" replace>登录</router-link>
      </div>
    </header>
    <div class="content">
      <Card>
        <Steps :current="current">
            <Step title="身份验证"></Step>
            <Step title="找回密码"></Step>
            <Step title="完成"></Step>
        </Steps>

        <div style="margin-top:40px;" v-if="current === 0">
          <Form ref="" style="width:400px;margin:0 auto;">
            <FormItem prop="userName" class="input-wrap">
              <Input v-model="form.phone" type="number" placeholder="请输入手机号">
                <span slot="prepend">
                  <Icon :size="16" type="bianzu2"></Icon>
                </span>
              </Input>
            </FormItem>
            <FormItem prop="password" >
              <Row class="input-wrap">
                <Col span="15">
                  <Input type="text" v-model="form.code" placeholder="请输入验证码">
                    <span slot="prepend">
                      <Icon :size="14" type="bianzu"></Icon>
                    </span>
                  </Input>
                </Col>
                <Col span="9" class="code-wrap">
                  <div @click="handleGetCode" v-if="remain<=0">
                    <button class="codebtn" type="button" @click.stop="handleGetCode">获取验证码</button>
                  </div>
                  <div v-else>
                    <button class="codebtn" disabled>{{remain}}s后重新发送</button>
                  </div>
                </Col>
              </Row>
            </FormItem>
            <FormItem>
              <Button @click="checkCode" type="primary" long>下一步</Button>
            </FormItem>
          </Form>
        </div>
        <Alert type="warning" style="margin-top:40px" v-if="current === 0">
            没收到短信验证码？
            <template slot="desc">
              <p>1、网络通讯异常可能会造成短信丢失，请重新获取或稍后再试。</p>
            <p>2、请核实手机是否已欠费停机，或者屏蔽了系统短信。</p>
            <p>3、如果手机已丢失或停用， 请选择其他验证方式 。</p>
            <p>4、您也可以尝试将SIM卡移动到另一部手机，然后重试。</p>
        </template>
        </Alert>

        <div style="margin-top:40px;" v-if="current === 1">
          <Form ref="" style="width:400px;margin:0 auto;">
            <FormItem prop="userName" class="input-wrap">
              <Input v-model="pass1" type="password" placeholder="请输入密码">
                <span slot="prepend">
                  <Icon :size="16" type="bianzu"></Icon>
                </span>
              </Input>
            </FormItem>
            <FormItem prop="userName" class="input-wrap">
              <Input v-model="pass2" type="password" placeholder="确认新密码">
                <span slot="prepend">
                  <Icon :size="16" type="bianzu"></Icon>
                </span>
              </Input>
            </FormItem>
            <p style="font-size:12px;line-height:1.4;">必须是8-20英文字母、数字或符号(除空格)，至少包含1个大写字母，1个小写字母和1个数字</p>
            <FormItem>
              <Button @click="changePass" type="primary" long>确定</Button>
            </FormItem>
          </Form>
        </div>
        <div style="margin-top:40px;" v-if="current === 2">
          <Form ref="" style="width:400px;margin:0 auto;">
          <Alert>重置密码成功</Alert>
          <Button type="primary" @click="toLogin">返回登录</Button>
          </Form>
        </div>
      </Card>
      
    </div>
  </div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        current:0,
        remain: 0,
        form: {
          phone: "",
          code: ""
        },
        pass1:'',
        pass2:''
      }
    },
    methods: {
      toLogin(){
        this.$router.push({
          name:'login'
        })
      },
      changePass(){
        if(this.pass2!==this.pass1){
          this.$Message.error({
            content: "两次密码不一致"
          });
          return;
        }

        var passEeg = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/)
        if (!passEeg.test(this.pass1)) {
          this.$Message.error({
            content: "密码强度不够"
          });
          return;
        }
        this.$axios
          .request({
            url: "api/passport/resetPass",
            method: "post",
            data: {phone:this.form.phone, token: this.form.phone, code:this.form.code,password:this.pass1 }
          }).then(res=>{
            this.current = 2;
          })

      },
      valide(phoneOrEmail) {
        if (!phoneOrEmail) {
          return false;
        }
        var emailReg = new RegExp(
          /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
        );
        var phoneReg = new RegExp(/^1\d{10}$/);
        if (phoneReg.test(phoneOrEmail)) {
          return "phone";
        }

        return false;
      },
      checkCode(){
        this.$axios
            .request({
              url: "api/passport/checkCode",
              method: "post",
              data: { token: this.form.phone, code:this.form.code }
            }).then(res=>{
              this.current = 1;
            })
      },
      handleGetCode() {
        var that = this;
        var valid = this.valide(this.form.phone);
        if (!valid) {
          this.$Message.error({
            content: "请输入正确的手机号"
          });
          return false;
        } else if (valid === "phone") {
          that.remain = 60;
          var interval = setInterval(function() {
            if (that.remain > 0) {
              that.remain--;
            } else {
              clearInterval(interval);
              interval = null;
            }
          }, 1000);
          this.$axios
            .request({
              url: "api/passport/sendSms",
              method: "post",
              data: { token: this.form.phone }
            })
            .then(res => {
              if (res.success) {
                this.$Message.success({
                  content: "验证码发送成功"
                });
              } else {
                this.$Modal.error({
                  title: "提示",
                  content: res.error.message,
                  showCancel: false
                });
                clearInterval(interval);
                interval = null;
                that.remain = 0;
              }
            });
        }
      },
    }
    
  }
</script>

<style lang="less" scoped>
header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 88px;
  background: rgba(81, 90, 110, 1);
  padding: 0 230px;
  color: #fff;
}
.logo-con {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: bold;
  img {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    margin-right: 10px;
  }
}
.login-url {
  color: #fff;
  font-size: 16px;
}
.content {
  h2 {
    text-align: center;
    margin-bottom: 20px;
  }
  padding: 50px 230px;
  border: none;
}
.code-wrap {
      box-sizing: border-box;
      height: 32px;
      line-height: 20px;
      padding: 6px 0;
      box-sizing: border-box;
      .codebtn {
        width: 100%;
        display: block;
        color: #d6000f;
        border: none;
        border-left: 1px solid rgba(54, 62, 79, 0.1);
        outline: none;
        cursor: pointer;
        background:white;
      }
    }
</style>